import React from 'react';
import { Divider } from 'semantic-ui-react';
import { compose } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import Content from '../Content';
import PaginationWrapper from '../PaginationWrapper';
import ClaimsFilters from './ClaimsFilters';
import ClaimsList from './ClaimsList';
import mapConnection from '../../utils/connectionMapper';
import PathView from '../PathView';
import withClaimsListQuery from './withClaimsListQuery';
import { withPagination } from '../../utils/pagination';
import withFilterActions from '../HOC/withFilterActions';

const initialFilters = {
  flightNumbers: [],
  airlineNames: [],
  crmStates: [],
  countryNames: [],
  reasons: [],
  passengerTicketsFullNames: [],
  ids: [],
  passengerEmails: [],
};

const MenuItems = withFilterActions('claims')(initialFilters)(ClaimsFilters);

const ClaimsListPage = ({ claimsConnection, loading }) => {
  const allClaims = mapConnection(claimsConnection);

  const { pageInfo, totalCount } = claimsConnection ? claimsConnection : {};

  return (
    <Content MenuItems={MenuItems} loading={loading}>
      <PathView paths={[{ name: 'Claims' }]} />
      <Divider hidden />
      {allClaims && <ClaimsList allClaims={allClaims} asLink={true} />}
      <Divider hidden />
      <PaginationWrapper {...pageInfo} totalCount={totalCount} />
    </Content>
  );
};

export default compose(
  withPagination(initialFilters),
  withRouter,
  withClaimsListQuery
)(ClaimsListPage);



// WEBPACK FOOTER //
// ./src/component/ClaimsListPage/index.js